/**
 * Dựng đúng thân request mà POST /auth/register nhận.
 *
 * Tách khỏi component vì đây là chỗ đã sai một lần và sai im lặng: form giữ nhiều
 * trường hơn API nhận (confirm_password, username, avatar, otp...), nên "gửi cả cục
 * formData đi" trông vẫn chạy cho tới khi một trường thừa đụng vào luật validate.
 *
 * Hai luật, đọc từ AuthRegisterLoginDto bên sportbook-backend:
 *
 *   - `profilePicture` khai @IsOptional() + @IsBase64(). Vậy CÓ ảnh thì gửi base64
 *     trần (đã cắt tiền tố "data:image/png;base64,"), KHÔNG có ảnh thì BỎ HẲN khoá.
 *     Trước đây chỗ này đặt cứng 'https://placehold.co/96x96' làm mặc định - một URL
 *     không phải base64, nên mọi lần đăng ký không chọn ảnh đều bị 422.
 *   - `email` khai @IsOptional() + @IsEmail(). Chuỗi rỗng trượt IsEmail, nên cũng bỏ
 *     hẳn khoá thay vì gửi ''.
 */
export type RegisterForm = {
  name: string;
  username: string;
  phone: string;
  password: string;
  email: string;
  [khac: string]: any;
};

export type RegisterPayload = {
  name: string;
  phone: string;
  password: string;
  email?: string;
  profilePicture?: string;
};

export const registerPayload = (form: RegisterForm, anhBase64: string | null): RegisterPayload => {
  // Số điện thoại người dùng gõ ở ô tên "username"; API gọi nó là "phone".
  const payload: RegisterPayload = {
    name: form.name,
    phone: form.username || form.phone,
    password: form.password,
  };

  const email = (form.email ?? '').trim();
  if (email) {
    payload.email = email;
  }

  const anh = (anhBase64 ?? '').trim();
  if (anh) {
    payload.profilePicture = anh;
  }

  return payload;
};
